<template>
    <div v-if="visitedViews.length" class="tags" :style="{'display': !FullScreenShow ? 'none' : 'block'}">
        <ul>
            <li class="tags-li" v-for="tag in visitedViews" :class="{'active': isActive(tag.name)}" :key="tag.path">
                <router-link ref="tag" :to="tag.path" class="tags-li-title" @click.prevent.native="openMenu(tag, $event)">
                    {{tag.title}}
                </router-link>
                <span class="tags-li-icon" @click.prevent.stop="closeSelectedTag(tag)"><i class="el-icon-close"></i></span>
            </li>
        </ul>
        <div class="tags-close-box">
            <el-dropdown @command="handleTags">
                <el-button size="mini" type="primary">
                    标签选项<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu size="small" slot="dropdown">
                    <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                    <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
// import bus from './bus'
import user from '../store/user/index'
import { routes } from '../router'
import path from 'path'
export default {
  data () {
    return {
      selectedTag: {},
      affixTags: []
    }
  },
  methods: {
    isActive (name) {
      return name === this.$route.name
    },
    filterAffixTags (routes, basePath = '/') {
      let tags = []
      routes.forEach((route) => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags () {
      const affixTags = (this.affixTags = this.filterAffixTags(routes))
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags () {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag () {
      const tags = this.$refs.tag
      if (tags) {
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              /* this.$refs.scrollPane.moveToTarget(tag) */
              // when query is different then update
              if (tag.to.fullPath !== this.$route.fullPath) {
                this.$store.dispatch('tagsView/updateVisitedView', this.$route)
              }
              break
            }
          }
        })
      }
    },
    closeOthersTags () {
      this.$router.push(this.selectedTag)
      this.$store
        .dispatch('tagsView/delOthersViews', this.selectedTag)
        .then(() => {
          this.moveToCurrentTag()
        })
    },
    closeAllTags (view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some((tag) => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    closeSelectedTag (view) {
      this.$store
        .dispatch('tagsView/delView', view)
        .then(({ visitedViews }) => {
          if (this.isActive(view.name)) {
            this.toLastView(visitedViews, view)
          }
        })
    },
    toLastView (visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        this.$router.push('/')
      }
    },
    handleTags (command) {
      command === 'other' ? this.closeOthersTags() : this.closeAllTags()
    },
    openMenu (tag, e) {
      this.selectedTag = tag
    },
    // 关闭指定窗口
    closeCurrentTag () {
      let sidebarRoute = routes
      if (sidebarRoute.length) {
        sidebarRoute.forEach((ele, index) => {
          if (this.tagPush === ele.path) {
            this.closeCurrentAndPointTag(this.$route, ele)
          } else if (this.tagName && this.tagName === ele.name) {
            this.closeCurrentAndPointTag(this.$route, ele)
          } else {
            if (ele.children && ele.children.length) this.coverTreeCloseCurrentTag(ele.children)
          }
        })
      }
    },
    coverTreeCloseCurrentTag (children) {
      children.forEach((ele, index) => {
        if (this.tagPush === ele.path) {
          this.closeCurrentAndPointTag(this.$route, ele)
        } else if (this.tagName && this.tagName === ele.name) {
          this.closeCurrentAndPointTag(this.$route, ele)
        } else {
          if (ele.children && ele.children.length) this.coverTreeCloseCurrentTag(ele.children)
        }
      })
    },
    closeCurrentAndPointTag (currentView, pointView) {
      let that = this
      that.$store
        .dispatch('tagsView/delView', currentView)
        .then(({ visitedViews }) => {
          that.$store
            .dispatch('tagsView/delView', pointView)
            .then(({ visitedViews }) => {
              if (that.tagPush) {
                that.$router.push(that.tagPush)
              } else {
                that.$router.push('/')
              }
            })
        })
    }
  },
  computed: {
    visitedViews () {
      return this.$store.state.tagsView.visitedViews
    },
    // 是否开启全屏
    FullScreenShow () {
      return user.state.FullScreenShow
    },
    tagsMark () {
      return user.state.tagsMark
    },
    tagPush () {
      return user.state.tagPush
    },
    tagName () {
      return user.state.tagName
    }
  },
  watch: {
    $route () {
      this.selectedTag = this.$route
      this.addTags()
      this.moveToCurrentTag()
    },
    tagsMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          this.closeCurrentTag()
          user.state.tagsMark = 0
        }
      }
    }
  },
  mounted () {
    this.initTags()
    this.addTags()
  }
}
</script>

<style>
    .tags {
        position: relative;
        height: 30px;
        overflow: hidden;
        background: #fff;
        padding-right: 120px;
        box-shadow: 0 5px 10px #ddd;
        z-index: 1;
    }

    .tags ul {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }

    .tags-li {
        float: left;
        margin: 3px 5px 2px 3px;
        border-radius: 3px;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;
        height: 23px;
        line-height: 23px;
        border: 1px solid #e9eaec;
        background: #fff;
        padding: 0 5px 0 12px;
        vertical-align: middle;
        color: #666;
        -webkit-transition: all .3s ease-in;
        -moz-transition: all .3s ease-in;
        transition: all .3s ease-in;
    }

    .tags-li:not(.active):hover {
        background: #f8f8f8;
    }

    .tags-li.active {
        color: #fff;
    }

    .tags-li-title {
        float: left;
        max-width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #666;
    }

    .tags-li.active .tags-li-title {
        color: #fff;
    }

    .tags-close-box {
        position: absolute;
        right: 10px;
        top: 0;
        box-sizing: border-box;
        padding-top: 1px;
        text-align: center;
        /*width: 110px;*/
        /*height: 30px;*/
        background: #fff;
        box-shadow: -3px 0 15px 3px rgba(0, 0, 0, .1);
        z-index: 10;
    }

</style>



// WEBPACK FOOTER //
// src/layout/TagsView.vue